import { render, staticRenderFns } from "./CommonFooter.vue?vue&type=template&id=2bad210e&scoped=true"
import script from "./CommonFooter.vue?vue&type=script&lang=js"
export * from "./CommonFooter.vue?vue&type=script&lang=js"
import style0 from "./CommonFooter.vue?vue&type=style&index=0&id=2bad210e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bad210e",
  null
  
)

export default component.exports